import OnlinesLogo from "shared/assets/logos/OnlinesLogo";
import { BrndLogo } from "shared/navbars/logos/BrndLogo";
import { greenAwardLogo } from "shared/navbars/logos/GreenAwardLogo";
import { HSEColorsLogo } from "shared/navbars/logos/HseColorsLogo";
import { HSELogo as Hselogo } from "shared/navbars/logos/HseLogo";
import { HSESpaceLogo as HseSpaceLogo } from "shared/navbars/logos/HseSpaceLogo";
import { KiiidsArtLogo } from "shared/navbars/logos/KiiidsArtLogo";
import { LmsCreativeLogo } from "shared/navbars/logos/LmsCreativeLogo";
import { LPULogo } from "shared/navbars/logos/LPULogo";
import { MediiiaLogo } from "shared/navbars/logos/MediiiaLogo";
import { Portfolio365Logo } from "shared/navbars/logos/Portfolio365Logo";

export const logoList = {
    mediiia: MediiiaLogo,
    hsedesign: Hselogo,
    hsespace: HseSpaceLogo,
    hsecolors: HSEColorsLogo,
    lmscreative: LmsCreativeLogo,
    brnd: BrndLogo,
    portfolio365: Portfolio365Logo,
    kiiids: KiiidsArtLogo,
    onlines: OnlinesLogo,
    lpu: LPULogo,
    greenAwardLogo: greenAwardLogo
}import OnlinesLogo from "shared/assets/logos/OnlinesLogo";
import { BrndLogo } from "shared/navbars/logos/BrndLogo";
import { greenAwardLogo } from "shared/navbars/logos/GreenAwardLogo";
import { HSEColorsLogo } from "shared/navbars/logos/HseColorsLogo";
import { HSELogo as Hselogo } from "shared/navbars/logos/HseLogo";
import { HSESpaceLogo as HseSpaceLogo } from "shared/navbars/logos/HseSpaceLogo";
import { KiiidsArtLogo } from "shared/navbars/logos/KiiidsArtLogo";
import { LmsCreativeLogo } from "shared/navbars/logos/LmsCreativeLogo";
import { LPULogo } from "shared/navbars/logos/LPULogo";
import { MediiiaLogo } from "shared/navbars/logos/MediiiaLogo";
import { Portfolio365Logo } from "shared/navbars/logos/Portfolio365Logo";

export const logoList = {
    mediiia: MediiiaLogo,
    hsedesign: Hselogo,
    hsespace: HseSpaceLogo,
    hsecolors: HSEColorsLogo,
    lmscreative: LmsCreativeLogo,
    brnd: BrndLogo,
    portfolio365: Portfolio365Logo,
    kiiids: KiiidsArtLogo,
    onlines: OnlinesLogo,
    lpu: LPULogo,
    greenAwardLogo: greenAwardLogo
}